import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles({
	radioList: {
		padding: 10,
		color: '#000733',
	},
	radioListItem: {
		marginLeft: 0,
		marginTop: 10,
	},
});
